<template>
  <div class="video-player-container">
    <ym-d-player v-if="canPlay"
                 :id="program.id"
                 :audio-id="program.audioId"
                 type="program"
                 :cover="program.cover"
                 :source="source"
                 :duration="program.duration"
                 @ended="handleEnded"
    />
    <div v-else-if="program.id > 0"
         class="player-join-hint-container"
    >
      <ym-img class="player-join-hint-cover"
              :src="program.cover"
              :alt="program.title"
      />
      <div class="player-join-hint-mask">
        <span class="player-join-hint-hint">订阅后即可观看</span>
      </div>
    </div>
    <img v-else
         class="video-player-container-loading"
         :src="require('@/assets/img/default/loading.gif')"
         alt="视频加载中"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import PlayerPlaylistStorageMixin from '@/mixins/player/playerPlaylistStorage';
  import YmDPlayer from '@/components/YmVideo/DPlayer';

  export default {
    name: 'VideoProgramControl',
    mixins: [PlayerPlaylistStorageMixin],
    components: {
      YmDPlayer,
    },
    props: {
      program: {
        type: Object,
        required: true,
      },
      canPlay: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      ...mapGetters([
        'videoPlaylist',
      ]),
      source() {
        const { program } = this;
        const { source } = program;
        const { mp4 } = source;
        if (mp4 instanceof Array) {
          return mp4[0];
        }
        if (typeof mp4 === 'string') {
          return mp4;
        }
        return '';
      },
    },
    methods: {
      handleEnded() {
        const { program } = this;
        const { id, mediaType } = program;
        // 获取全局播放列表
        const playlist = this.videoPlaylist;
        const { length } = playlist;
        if (length === 1) return;

        // 获取接下来播放的资源信息
        const index = playlist.findIndex(item => item.id === id);
        const nextIndex = index + 1;

        if (nextIndex > length) return;

        const nextMediaType = playlist[nextIndex].mediaType;
        const nextId = playlist[nextIndex].id;

        // 判断是否为同一类型资源
        if (mediaType === nextMediaType) {
          const route = { name: 'VideoProgramDetail', params: { id: nextId } };
          this.$router.push(route);
          return;
        }
        this.$dialog.confirm({
          title: '播放提示',
          message: '下一讲为音频讲，是否要切换到音频模式，收听该讲音频？',
          confirmButtonText: '收听音频',
          cancelButtonText: '取消',
        }).then(() => {
          const route = { name: 'AudioProgramDetail', params: { id: nextId } };
          this.$router.push(route);
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @player-width: 750px;
  @player-height: 420px;

  .video-player-container {
    &-loading {
      display: block;
      width: @player-width;
      height: @player-height;
    }
  }

  .player-join-hint-container {
    position: relative;
    width: @player-width;
    height: @player-height;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .player-join-hint-cover {
    display: block;
    width: 100%;
    height: 100%;
  }

  .player-join-hint-mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(34, 34, 34, 0.7);
  }

  @player-join-hint-height: 60px;
  .player-join-hint-hint {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: @player-join-hint-height;
    padding: 0 @size-extra-medium;
    border-radius: @player-join-hint-height / 2;
    background: fade(@color-white, 90);
    border: @border-base;
  }
</style>
